module.exports = __webpack_public_path__ + "static/media/Emblem_of_Laos.svg_.9d2126db.png";